import React from 'react';
import { CheckIcon, TargetIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { volumes } from '../data/content';
export function Volumes() {
  return <section className="bg-white py-14 sm:py-20" data-id="element-320" data-mp="1856kgc4svjgc">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-321" data-mp="1c5grls4bwfws">
        <SectionHeading eyebrow="All’interno del sistema" title="Un sistema. Sei volumi clinici. Un percorso TRT completo." subtitle="Non è un altro manuale destinato a rimanere sullo scaffale, né un corso di 20 ore che non finirai mai. È un riferimento clinico pratico costruito attorno all’intero percorso del paziente in TRT." data-id="element-322" data-mp="1c60c9gld5iei" />

        <div className="mt-10 space-y-5" data-id="element-323" data-mp="1vseq4v654uiw">
          {volumes.map(volume => <article key={volume.number} className="overflow-hidden rounded-2xl border border-navy-900/10 bg-white shadow-[0_14px_35px_-28px_rgba(7,20,41,0.7)]" data-id="element-324" data-mp="feojbgnmzs5k">
              <div className="bg-navy-900 px-5 py-4 sm:px-6" data-id="element-325" data-mp="3o7n6t228zfxq">
                <span className="text-[10px] font-black uppercase tracking-[0.22em] text-gold-400" data-id="element-326" data-mp="3o9zvdy2igojr">
                  {volume.number}
                </span>
                <h3 className="mt-1.5 text-[17px] font-black uppercase leading-tight tracking-tight text-white sm:text-2xl" data-id="element-327" data-mp="21q7k688wsvz">
                  {volume.title}
                </h3>
              </div>

              <div className="px-5 py-5 sm:px-6" data-id="element-328" data-mp="b0byoprs9g8d">
                <p className="text-[14px] leading-relaxed text-navy-900/70 sm:text-[15px]" data-id="element-329" data-mp="62jw91tiibpx">
                  {volume.intro}
                </p>

                <p className="mt-5 text-[10px] font-black uppercase tracking-[0.18em] text-navy-900/45" data-id="element-330" data-mp="kq4x0p2wzyuo">
                  {volume.listLabel}
                </p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-331" data-mp="truzqr28yk7r">
                  {volume.items.map(item => <li key={item} className="flex items-start gap-2 text-[14px] font-medium leading-snug text-navy-900" data-id="element-332" data-mp="pr2ndoy2vz79">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-600" aria-hidden="true" data-id="element-333" data-mp="11skfmofj8pxu" />
                      {item}
                    </li>)}
                </ul>

                {volume.goal && <p className="mt-5 flex gap-2.5 rounded-lg bg-navy-50 p-3.5 text-[13px] font-semibold leading-snug text-navy-900 sm:text-sm" data-id="element-334" data-mp="1fkqm1isvvik3">
                    <TargetIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-600" aria-hidden="true" data-id="element-335" data-mp="1khqvm3oxz3fy" />
                    <span data-id="element-336" data-mp="1uhrh9waa9vnb">
                      <span className="font-black uppercase tracking-wide" data-id="element-337" data-mp="1ugzlolgorxx1">
                        L’obiettivo:{' '}
                      </span>
                      {volume.goal}
                    </span>
                  </p>}
              </div>
            </article>)}
        </div>

        <div className="mt-10 flex justify-center" data-id="element-338" data-mp="2dfung097bnsx">
          <CtaBlock label="Ottieni i 6 volumi clinici" note="Accesso digitale immediato · Pagamento unico · 19 EUR" data-id="element-339" data-mp="28mrplfxe5s6x" />
        </div>
      </div>
    </section>;
}